module.exports = __webpack_public_path__ + "static/media/kinder-morgan.a0eba570.svg";